import { TRP_DOMAINS } from '@trp-dms-digital-shared/ds-ui-library-common';

import { dependencies } from '../../../../../package.json' with { type: 'json' };

// should have installed a current `latest` version
export const BEACON_DEFAULT_VERSION = dependencies[
  '@trp-beacon-ui-kit/foundation'
]?.replace(/[^0-9.]/g, '');

// should only be current versions on CDN
export const BEACON_VERSIONS = ['4.8.1', '4.12.0', '4.13.3', 'next'];
// path from root of TRP Domain
export const BEACON_URL_ROOT_PATH = 'foundation';
// register path from version of Beacon URL
export const BEACON_REGISTER_PATH = 'components/register.js';
// full URL to Beacon docs on how to use the CDN
export const BEACON_DOCS_URL_CDN =
  'https://ui-kit.gitlab-pages.awstrp.net/foundation/main/storybook/?path=/docs/usage-cdn--docs';

/**
 * root URLs for the CDN
 */
export const BEACON_URL_ROOTS = {
  DEV: new URL(BEACON_URL_ROOT_PATH, TRP_DOMAINS.DEV).href,
  STAGE: new URL(BEACON_URL_ROOT_PATH, TRP_DOMAINS.STAGE).href,
  PROD: new URL(BEACON_URL_ROOT_PATH, TRP_DOMAINS.PROD).href,
} as const;

/**
 * Beacon CSS paths from beacon domain root
 */
export const BEACON_CSS_FILES = {
  FONTS: 'fonts/fonts.css',
  VARIABLES: 'style-tokens/css/unscoped-variables.css',
  STYLE: 'css/style.css',
} as const;
